<template>
    <div class="input-group">
        <template v-if="toDetail">
            <number-controller :params="numberControllerParams" @triggerEvent="numberControllerEvent" :size="'mini'"/>
        </template>
        <template v-if="!toDetail">
            <div class="num">x {{ recordItem.amount }}</div>
        </template>

        <div class="name" @click="Check">{{ toDetail ? `${couponTypeName}${mealDataDetail.posFoodInfo.onlineOrderName}` : recordItem.name }}</div>
        <div class="fee" @click="Check">$ {{ toDetail ? item.choicePrice : recordItem.totalPrice }}</div>
        <div class="detail" @click="Check" v-html="noteString"></div>
    </div>
</template>

<script>

    import NumberController from "@/components/NumberController";
    import * as constDefine from "@/store/constDefine";

    export default {
        name: "Meal",
        components: {
          NumberController
        },
        props: {
            toDetail:Boolean,
            item:{required: false, type: Object, default: null},
            mealData:{required: false},
            index:{required: true},
            recordItem:{required:false},
            takeoutId:{required:false,type:Number,default:0},
        },
        data() {
            return {
                num: this.toDetail ? this.item.amount : 0,
                mealDataDetail: null,
                combination: null,
                noteString: '',

                numberControllerParams: {
                    default: 0,
                    min: 0,
                    max: 999,
                    isDisabled: false,
                },
                isCordova: this.$public.isCordova(),
                isDisableModify: this.toDetail ? this.item.isDisableModify : false,
                couponTypeName: "",
            }
        },
        created() {
            this.setupData();
        },
        mounted() {
            this.numberControllerParams.default = this.num

            if (this.isDisableModify) {
                this.numberControllerParams.min = this.item.amount
                this.numberControllerParams.max = this.item.amount
                this.numberControllerParams.isDisabled = true

                if (this.item.couponTypeId === 1) {
                    this.couponTypeName = "[兌換] "
                } else if (this.item.couponTypeId === 3) {
                    this.couponTypeName = "[加價] "
                }
            }
        },
        methods: {
            Check() {
                //前往詳細
                if (this.toDetail) {
                    if (this.isDisableModify) {
                        return this.$public.showNotify('請取消優惠券再調整餐點', false);
                    }
                    if (!this.isCordova) {
                        try {
                            let dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
                            dataObject = {
                                ...dataObject, ...{
                                    "posFoodId": this.mealDataDetail.posFoodInfo.id,
                                    "takeoutId": this.takeoutId,
                                }
                            }
                            sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(dataObject));
                        } catch (error) {
                            // console.log(error)
                        }
                    }

                    this.$router.push({
                        name: 'OrderDetail',
                        params: {
                            choiceList: this.combination,
                            textNote: this.item.text_note,
                            choiceAmount: this.num,
                            choiceListId: this.item.id,
                            takeoutId: this.takeoutId
                        },
                        query: {'id': this.mealDataDetail.posFoodInfo.id}
                    });
                }
            },
            setupData(){
                if (this.toDetail) {
                    for (const key in this.mealData) {
                        if (Object.hasOwnProperty.call(this.mealData, key)) {
                            const element = this.mealData[key];
                            if (element.meal_id===this.item.meal_id) {
                                this.mealDataDetail = element;
                            }
                        }
                    }
                    if (this.mealDataDetail!==null) {
                        this.mealDataDetail = JSON.parse(this.mealDataDetail.data_json);
                        let mealDataDetailDataList = this.mealDataDetail.dataList.filter((fitem)=>{return fitem.noteType !== 1;});
                        this.combination = JSON.parse(this.item.combination_json);
                        if (this.mealDataDetail.posFoodInfo.orderType===1) {
                            this.combination.forEach((element,index) => {
                                // if (element.length>0) {
                                //     this.noteString += mealDataDetailDataList[index].posGoodsNoteName+'-';
                                // }
                                element.forEach((element2,index2)=>{
                                    let note = mealDataDetailDataList[index].posGoodsNoteDetailList[element2];
                                    this.noteString += note.name;
                                    if (note.increasePrice !== 0) {
                                        this.noteString += '('+(note.increasePrice>0?'+$'+Math.abs(note.increasePrice):''+note.increasePrice<0?'-$'+Math.abs(note.increasePrice):'')+')';
                                    }
                                    this.noteString += '、';
                                });
                            });

                            if(this.noteString.slice(-1) === '、') {
                              this.noteString = '<p>'+this.noteString.substr(0,this.noteString.length-1)
                            }

                            if(typeof this.item.text_note !== "undefined" && this.item.text_note !== "" && this.item.text_note !== null) {
                              this.noteString = '<p>'+(this.noteString === "" ? this.item.text_note : this.noteString + '、' + this.item.text_note)
                            }

                        }else if (this.mealDataDetail.posFoodInfo.orderType===2) {
                            this.combination[0].forEach((element,index)=>{
                                let m = mealDataDetailDataList[index];
                                //this.noteString += m.name+'-';
                                let n = m.posFoodSubmealList[element];
                                this.noteString += '<p>'+n.posFoodName;
                                if (n.increasePrice !== 0) {
                                    this.noteString += '('+(n.increasePrice>0?'+$'+Math.abs(n.increasePrice):''+n.increasePrice<0?'-$'+Math.abs(n.increasePrice):'')+')';
                                }
                                this.combination[1][index][element].forEach((element2,index2)=>{
                                    element2.forEach((element3,index3)=>{
                                        let note = n.posFoodGoodsNoteList[index2].posGoodsNoteDetailList[element3];
                                        this.noteString += '、'+note.name;
                                        if (note.increasePrice !== 0) {
                                            this.noteString += '('+(note.increasePrice>0?'+$'+Math.abs(note.increasePrice):''+note.increasePrice<0?'-$'+Math.abs(note.increasePrice):'')+')';
                                        }
                                    });
                                });
                                //this.noteString += '<br>';
                            });
                        }
                    }
                    this.$forceUpdate();
                } else {
                    let linkSymbol = '';
                    this.recordItem.comboList.forEach((item,index)=>{
                        this.noteString += '<p>'+item.name;
                        item.noteList.forEach((item2,index2)=>{
                            if (index2===0) {
                                linkSymbol = ' - ';
                            }else{
                                linkSymbol = '、';
                            }
                            this.noteString += linkSymbol+item2.name;
                        })
                        //this.noteString += '<br>';
                    });
                    this.recordItem.noteList.forEach((item,index)=>{
                        if(typeof this.recordItem.noteText !== "undefined" || this.recordItem.noteText !== "" || this.recordItem.noteText !== null){
                            this.noteString= '<p>'+this.noteString
                        }
                        if (index !== 0) {
                            linkSymbol = '、';
                        }
                        this.noteString += linkSymbol+item.name;
                    });

                    if(typeof this.recordItem.noteText !== "undefined" && this.recordItem.noteText !== "" && this.recordItem.noteText !== null) {
                        if(this.recordItem.type === 2) {
                            this.noteString += '<p>' + this.recordItem.noteText;
                        } else {
                            this.noteString = (this.noteString === "" ? '<p>'+this.recordItem.noteText : this.noteString + '、' + this.recordItem.noteText)
                        }
                    }
                }
            },
            setNum(setVal){
                this.num = setVal;
            },
            numberControllerEvent(obj) {
              let self = this;
              let event = obj.event;

              if (event === "returnNumber") {
                self.num = obj.number
              }
            },
        },
        watch: {
            num:{
                handler:function (newVal,oldVal) {
                    if (this.toDetail) {
                        if (oldVal!==undefined) {
                            if(newVal!==0&&oldVal!==0){
                                this.item.choicePrice = this.item.choicePrice/oldVal*newVal;
                            }
                            this.$emit('mealResult',this.index,newVal,oldVal,this.item.choicePrice);
                            this.numberControllerParams.default = this.num
                        }
                    }
                },
                deep : true ,
                immediate : true,
            },
        }
    }
</script>

